// ABOUTME: Registers custom components used by the canonical User forms.
// ABOUTME: Keeps branch authorization controls outside the User form registry.
import React from "react";
import UserAuthorization from "./UserAuthorization";

const CustomComponents = [
    {
        name: "FeaturesAccessList",
        component: UserAuthorization
    }
];

export default CustomComponents;
